import { Search, Filter, SlidersHorizontal, ChevronDown } from 'lucide-react';

const TableToolbar = () => {
  return (
    <div className="flex items-center justify-between p-4">
      <div className="relative">
        <Search className="committee-search-icon absolute left-[18px] top-1/2 -translate-y-1/2" />

        <input type="text" placeholder="Search Committees" className="committee-search-input pl-[46px]" />
      </div>

      <div className="flex items-center gap-3">
        <button className="table-filter-button">
          <Filter className="table-filter-icon" />

          <span>Filter</span>

          <ChevronDown className="table-filter-icon" />
        </button>

        <button className="table-settings-button">
          <SlidersHorizontal size={18} className="text-[#4F4F4F]" />
        </button>
      </div>
    </div>
  );
};

export default TableToolbar;
